import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { intlShape, injectIntl } from 'react-intl';
import { Field } from 'redux-form';
import _ from 'lodash';
import SelectField, { mapOptionsToSelectField } from '../../../shared-components/SelectField/SelectField';
import { isEmpty } from '../../../shared-components/FormElement/FormElementUtils';

export const LOCALE_PREFIX = 'DE/components/UserTitle/UserTitle';

export class UserTitle extends Component {
    static propTypes = {
        intl: intlShape.isRequired,

        // Plain k/v object with key:option value and value:display text mapping
        userNameTitleOptions: PropTypes.object.isRequired
    };

    render() {
        const { intl, userNameTitleOptions } = this.props;

        return (
            <Field
                id="userTitle"
                name="userTitle"
                component={SelectField}
                optionList={mapOptionsToSelectField(userNameTitleOptions)}
                required={true}
                label={intl.formatMessage({id: `${LOCALE_PREFIX}.userNameTitleLabel`})}
                placeholder={intl.formatMessage({id: `${LOCALE_PREFIX}.userNameTitleLabel`})}
                validate={[isEmpty(intl.formatMessage({id: `${LOCALE_PREFIX}.userNameTitleLabel-empty`}))]}
            />
        );
    }
}

export const mapStateToProps = state => ({
    // Grab the properties directly from the message object
    userNameTitleOptions: _.get(state, `serverData.messages.${LOCALE_PREFIX}.userNameTitleOptions`)
});

export default connect(mapStateToProps)(injectIntl(UserTitle));
